import { ProductPageProvider } from "@/components";
import { Spin } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { portalRequest, refreshPortalSession } from "../lib/auth";
import { getPortalLandingPath, portalPaths } from "../lib/routes";

type PortalSessionResponse = {
  actorType: "tenant_user" | "agency_user";
};

/** Restores a portal session at the domain root and sends the actor to the correct landing page. */
const PortalEntryRedirectPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    refreshPortalSession()
      .then(() => portalRequest<PortalSessionResponse>({ url: "/api/agent-portal/session", method: "get" }))
      .then((response) => {
        if (!cancelled) navigate(getPortalLandingPath(response.data.actorType), { replace: true });
      })
      .catch(() => {
        if (!cancelled) navigate(portalPaths.login, { replace: true });
      });

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <ProductPageProvider>
      <main className="flex min-h-[100dvh] items-center justify-center bg-[#FBFBFB]">
        <Spin size="large" />
      </main>
    </ProductPageProvider>
  );
};

export default PortalEntryRedirectPage;
